export default __webpack_public_path__ + "static/web28082023-963f2c1bf94818a8a6647fdd726f3eb8.jpg";